// extracted by mini-css-extract-plugin
export default {"title":"Admin_title__YMR7b","noItems":"Admin_noItems__EUBp1","content":"Admin_content__zsp+T","items":"Admin_items__VS9Ve","main":"Admin_main__wIXIJ"};